/**
 * Normalizes a string into the form of TitleCase.
 */
export function titleCase(str: string) {
    return (
        str
            // Remove anything that's not alphanumeric.
            .replace(/[^a-zA-Z0-9]/g, '')
            // Uppercase on each word boundary.
            .replace(/(?:^\w|[A-Z]|\b\w)/g, i => i.toUpperCase())
    );
}

/**
 * Normalizes a string into the form of camelCase.
 */
export function camelCase(str: string) {
    str = titleCase(str);
    return str.substring(0, 1).toLowerCase() + str.substring(1);
}